import { Button } from "@mui/material";
import styled from "styled-components";

export const BoxButtons = styled.div`
	@media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
		position: absolute;
		top: 15px;
		right: 0;
	}
`;

export const AreaButtonsIcons = styled.div`
	display: flex;
	flex-direction: row;
	gap: 0.2rem;

	@media (max-width: ${({ theme }) => theme.breakpoints.desktopSmall}) {
		display: none;
	}
	@media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
		display: flex;
	}
`;

export const AreaButtons3Dots = styled.div`
	display: none;

	@media (max-width: ${({ theme }) => theme.breakpoints.desktopSmall}) {
		display: block;
	}
	@media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
		display: none;
	}
`;
export const ButtonTrigger = styled(Button)`
	&&& {
		background: none;
		border: none;
		min-width: fit-content;
	}
`;
